/**
 * Defaults financieros de negocio — ÚNICA fuente de verdad.
 *
 * Regla del proyecto: nunca hardcodear tarifas en los puntos de uso.
 * Siempre priorizar el valor del perfil/registro y caer a estos defaults nombrados.
 */

/** Porcentajes historicos, solo para interpretar cierres anteriores. */
export const DEFAULT_ROYALTY_PERCENT_BASIC = 1;
export const DEFAULT_ROYALTY_PERCENT_PREMIUM = 3;

/**
 * Valor legacy que quedó guardado en borradores antiguos antes de existir
 * los packs. Se usa solo para detectar y migrar registros obsoletos.
 */
export const LEGACY_ROYALTY_PERCENT = 5;

/** Retención IRPF por defecto (%) cuando el registro no especifica una. */
export const DEFAULT_IRPF_PERCENT = 20;

/** Precio de renting por moto (€/mes) cuando no hay coste explícito. */
export const DEFAULT_RENTING_PRICE_PER_UNIT = 159;

/** Porcentaje de facturación reservado en la Hucha Fiscal (estimación). */
export const DEFAULT_TAX_VAULT_RATE = 0.15;

/** Coste laboral por hora (€/h) cuando el perfil no define uno. */
export const DEFAULT_HOURLY_RATE = 8.5;

/** Tipo general de IVA. */
export const STANDARD_VAT_RATE = 0.21;

/**
 * Tipo de IVA de cada partida de gasto.
 *
 * La flota nunca elige un tipo: cada partida lleva el suyo. Las de personal no
 * llevan IVA (no son una entrega de bienes ni una prestación de servicios sujeta)
 * y los seguros están exentos; para el cálculo ambos casos son cuota cero.
 */
export const EXPENSE_VAT_RATES: Record<string, number> = {
    // Sin IVA / exento
    payroll: 0,
    socialSecurity: 0,
    employerSocialSecurity: 0,
    quota: 0,
    insurance: 0,
    // Tipo general
    renting: STANDARD_VAT_RATE,
    fuel: STANDARD_VAT_RATE,
    repairs: STANDARD_VAT_RATE,
    subscription: STANDARD_VAT_RATE,
    flyder: STANDARD_VAT_RATE,
    agencyFee: STANDARD_VAT_RATE,
    marketing: STANDARD_VAT_RATE,
    repaartServices: STANDARD_VAT_RATE,
    incidents: STANDARD_VAT_RATE,
    other: STANDARD_VAT_RATE,
};

export const getDefaultRoyaltyPercent = (pack?: string | null): number =>
    pack === 'premium' ? DEFAULT_ROYALTY_PERCENT_PREMIUM : DEFAULT_ROYALTY_PERCENT_BASIC;
